import * as React from "react";
import { SelectCachedId } from "src/components/SelectCachedId";
import { ZSidLabel } from "src/types";

import { loadCatalog } from "../apiCatalog";
import { PropsSelectCatalog, SelectCatalog } from "./SelectCatalog";

type PropsSelectCatalogId = Omit<PropsSelectCatalog, "onChange" | "value"> & {
  value?: string;
  onChange?(newValue?: string): void;
};

export const SelectCatalogId: React.FC<PropsSelectCatalogId> = (props) => {
  const { value, onChange, ...baseProps } = props;
  const cache = React.useRef<Record<string, string>>({});
  return (
    <SelectCachedId
      BaseComponent={SelectCatalog}
      value={value}
      onChange={onChange}
      baseProps={baseProps}
      cache={cache.current}
      loadSidLabel={loadSidLabel}
    />
  );
};

const loadSidLabel = async (catalogId: string): Promise<ZSidLabel> => {
  const { id, name } = await loadCatalog(catalogId);
  return { id, label: name };
};
